import React from "react";
import AnimatedNumber from "animated-number-react";

const CustomAnimatedNumber = ({ value }) => {
  const formatValue = (value) => value.toFixed(0);

  return (
    <AnimatedNumber
      duration={1000}
      formatValue={formatValue}
      value={value}
      delay={100}
    />
  );
};

export default CustomAnimatedNumber;
